import { fork } from "redux-saga/effects";
import { orderPersonWatcher } from "./personListSagas";
import { orderFoodProductWatcher } from "./foodProductsListSaga";
import { landingListWatcher } from "./landingListSaga";
import { nightPlacementListWatcher } from "./nightPlacementListSaga";
import { orderDocumentsListWatcher } from "./orderDocuments";

export default function* Lists() {
  yield fork(orderFoodProductWatcher);
  yield fork(orderPersonWatcher);
  yield fork(landingListWatcher);
  yield fork(nightPlacementListWatcher);
  yield fork(orderDocumentsListWatcher);
}
